import { render } from "./messages.vue?vue&type=template&id=f54e25aa&ts=true"
import script from "./messages.vue?vue&type=script&lang=ts"
export * from "./messages.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Repos\\Sinter\\SinterAdmin\\src\\sa-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__